import authUrlConstnts from '../../constants/authUrlConstnts'

const login = () => authUrlConstnts.LOGIN_URL
const forgotPassword = () => authUrlConstnts.FORGOT_PASSWORD_URL
const resetPassword = () => authUrlConstnts.RESET_PASSWORD_URL
const refreshToken = () => authUrlConstnts.REFRESH_TOKEN_URL
const getUserDetails = (userId: string) => `${authUrlConstnts.GET_USER_DETAILS}${userId}/detailed`

export default {
  login,
  forgotPassword,
  resetPassword,
  refreshToken,
  getUserDetails,
}
